import { Part, partProps } from '@/Engine/Wardrobe/Part';
import { defaultTrouserRackOffsets } from '@/Constants/trouserRack';

export class TrouserRack extends Part {
    constructor(props: partProps) {
        super({ ...props, offsets: [ ...defaultTrouserRackOffsets ], ...props });
    }
}
